<template>
    <div v-if="isAllowedToViewUserResults">
        <b-row>
            <b-col cols lg="8" sm="12">
                <questionnaires
                    class="questionnaires"
                    multiple
                    defaultSelecteds
                    applyEvaluatedScope
                    :evaluatedId="user.id"
                    applyPublicationPermissionScope
                    :model="questionnaires"
                    @change="updateQuestionnaires"
                    @ready="updateQuestionnaireSelectIsReady(true)"
                    @without-options-available="withoutQuestionnairesAvailable = true"
                />
            </b-col>
            <b-col
                cols
                lg="4"
                sm="12"
                class="d-flex justify-content-lg-end justify-content-center mb-2 mb-lg-0 align-items-center font-weight-bold"
            >
                <router-link :to="`/v2/values/valuers/${user.id}`" class="justify-content-center">{{
                    networksLink
                }}</router-link>
            </b-col>
        </b-row>
        <b-alert v-if="withoutQuestionnairesAvailable" show>
            {{ $t('values.withoutQuestionnairesAvailable') }}
        </b-alert>
        <div v-else>
            <QuestionnaireResults
                class="mb-4"
                :user="user"
                :key="questionnaireResults.id"
                v-for="questionnaireResults in results"
                :questionnaireResults="questionnaireResults"
            />
        </div>
    </div>
    <b-alert v-else show>{{ $t('values.withoutPermissionToViewUserResults') }}</b-alert>
</template>
<script>
import { userPermissionsMixin } from '@/mixins'
import { mapActions, mapState, mapGetters } from 'vuex'
import { Questionnaires } from '@/views/values/components'
import QuestionnaireResults from './components/QuestionnaireResults'
import i18n from '@/i18n'

const VUEX_MODULE = 'questionnairesResults'

export default {
    mixins: [userPermissionsMixin],
    components: { Questionnaires, QuestionnaireResults },
    props: {
        user: {
            type: Object,
            required: true,
        },
        periodIds: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            withoutQuestionnairesAvailable: false,
        }
    },
    mounted() {
        this.updateEvaluated(this.user)
    },
    destroyed() {
        this.resetState()
    },
    watch: {
        user() {
            this.updateEvaluated(this.user)
        },
    },
    methods: {
        ...mapActions(VUEX_MODULE, [
            'resetState',
            'updateEvaluated',
            'updateQuestionnaires',
            'updateQuestionnaireSelectIsReady',
        ]),
    },
    computed: {
        ...mapGetters(VUEX_MODULE, ['questionnairesIds']),
        ...mapState(VUEX_MODULE, ['results', 'questionnaires', 'questionnaireSelectIsReady']),
        currentUser() {
            return this.$store.state.currentUser.user
        },
        networksLink() {
            return this.currentUser.id === this.user.id
                ? i18n.t('values.network.seeWhoCanEvaluateMe')
                : i18n.t('values.network.seeNetworkFromUser')
        },
        isAllowedToViewUserResults() {
            const availableRoles = ['god', 'administrator', 'local_administrator', 'is_values_master']

            if (this.userHasPermission(this.currentUser, availableRoles, [])) {
                return true
            }

            if (this.isCommitteeMember(this.currentUser.evaluator_committees, this.user.rated_committees)) {
                return true
            }

            if (this.currentUser.id == this.user.manager.id) {
                return true
            }

            return this.currentUser.id == this.user.id
        },
    },
}
</script>
<style lang="scss" scoped>
.questionnaires {
    max-width: 900px;
}
</style>
